export const ERROR_CODE = {
  LOAD_APPLICATION_FORM: {
    NOT_FOUND: 404,
    ALREADY_APPLIED: 400,
  },
  WITHDRAW: {
    FORBIDDEN: 403,
  },
} as const;
